<template> 
    <div class="alibaba-keywords-main">
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-date-picker type="date" placeholder="追踪开始日期" v-model="params.createDateStart" class="search-item" value-format="yyyyMMdd"></el-date-picker>
                <el-date-picker type="date" placeholder="追踪结束日期" v-model="params.createDateEnd" class="search-item" value-format="yyyyMMdd"></el-date-picker>

                <el-input v-model="params.clickRate2" placeholder="点击率(默认>=15)" class="search-item"></el-input>
                <el-input v-model="params.times" placeholder="允许偏离次数(默认2)" class="search-item"></el-input>
                <el-input v-model="params.addDays" placeholder="纳入天数(默认3)" class="search-item"></el-input>
                <el-input v-model="params.days" placeholder="存活天数(默认7)" class="search-item"></el-input>
            </el-row>
            <el-row class="search-row">
                <el-input v-model="params.pv" placeholder="搜索指数(默认>=5)" class="search-item"></el-input>
                <el-input v-model="params.resultCntEnd" placeholder="卖家规模(<)" class="search-item"></el-input>
                <el-input v-model="params.excludesQueryRaw" placeholder="屏蔽关键词(多个,号隔开)" class="search-item"></el-input>
                <el-button class="analysis-button" type="primary" size="small" @click="analysis" :loading="loadding">分析</el-button>
            </el-row>
        </div>
        <div class="data-div">
            <el-table border style="width: 100%" :height="this.$tools.mainHeight() - 105" :data="records">
                <el-table-column prop="date" label="日期" width="100"></el-table-column>
                <el-table-column prop="nall" label="实时全量" width="80"><template slot-scope="rdata"><el-link type="primary" disabled>{{ rdata.row.nall }}</el-link></template></el-table-column>
                <el-table-column prop="nadd" label="实时新增" width="80"><template slot-scope="rdata"><el-link type="primary" disabled>{{ rdata.row.nadd }}</el-link></template></el-table-column>
                <el-table-column prop="all" label="当日全量" width="80"><template slot-scope="rdata"><el-link type="info" disabled>{{ rdata.row.all }}</el-link></template></el-table-column>
                <el-table-column prop="add" label="当日新增" width="80"><template slot-scope="rdata"><el-link type="info" disabled>{{ rdata.row.add }}</el-link></template></el-table-column>
                <el-table-column prop="dec" label="当日减少" width="80"><template slot-scope="rdata"><el-link type="danger" disabled>{{ rdata.row.dec }}</el-link></template></el-table-column>
                <el-table-column prop="cor" label="偏离纠正" width="80"><template slot-scope="rdata"><el-link type="danger" disabled>{{ rdata.row.cor }}</el-link></template></el-table-column>
                <el-table-column prop="tdec" label="实际减少" width="80"><template slot-scope="rdata"><el-link type="danger" @click="showInfo(rdata.row.date, 'tdec', '实际减少')">{{ rdata.row.tdec }}</el-link></template></el-table-column>
                <el-table-column prop="rdata" label="当日输出" width="80"><template slot-scope="rdata"><el-link type="success" @click="showInfo(rdata.row.date, 'rdata', '当日输出')">{{ rdata.row.rdata }} ({{ rdata.row.mdata }})</el-link></template></el-table-column>
            </el-table>

        <el-drawer
            :title="showTitle + '详情'"
            :visible.sync="show"
            direction="btt"
            :destroy-on-close="true"
            :size="this.$tools.mainHeight() + 'px'"
            class="showdata-drawer"
        >   
            <div class="info-tagrow">
                <el-select class="search-item" v-model="tempLevels" multiple collapse-tags placeholder="请选择星级" @change="fiterLevel">
                    <el-option
                    v-for="item in levels"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                    </el-option>
                </el-select>
            </div>
            <div class="showdata-div" :style="'height:' + (this.$tools.mainHeight() - 55) + 'px'" v-infinite-scroll="next" infinite-scroll-immediate=false :infinite-scroll-disabled="disabled()"  infinite-scroll-delay="400">
                <el-row class="showdata-row" v-for="sd in tempData" :key="sd">
                    <el-col :span="4">
                        <el-row><el-col>{{ sd.key }}</el-col></el-row>
                        <el-row><el-col>{{ tranTxt[sd.key] }}</el-col></el-row>
                        <el-row><el-col><el-rate v-model="sd.l" :colors="colors" @change="changeLevel(sd.key, sd.l)"></el-rate></el-col></el-row>
                        <el-row><el-col>
                            <div class="alibaba-keywords-div-out">
                                <div class="alibaba-keywords-div" v-for="(v, index) in sd.t.split(',')" :key="index" :style="getGradient(v, sd.t)" :title="v">
                                    &nbsp;
                                </div>
                            </div>
                        </el-col></el-row>
                    </el-col>
                    <el-col :span="20">
                        <div :id="sd.key"></div>
                    </el-col>
                </el-row>

                <div class="totle-box" v-if="stotle > 0">
                    <span v-if="ssize * spage < stotle">{{ssize * spage}}/{{stotle}}</span>
                    <span v-else>{{stotle}}/{{stotle}}</span>
                </div>

                <div class="infinite-box-more">
                    <p v-if="!disabled()">加载中....</p>
                    <p v-if="disabled()">没有更多了...</p>
                </div>
            </div>
        </el-drawer>
        </div>
    </div>
</template>

<script>

import {
    Chart,
    registerInteraction,
    registerAction,
    ActionConstructor,
    getDelegationObject,
} from "@antv/g2";

export default {
    data() {
        return {
            params: {},
            loadding: false,
            days: null,
            token: null,
            records: null,
            show: false,
            showData: null,
            tempData: null,
            chars: null,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            levels: [{key: 0, value: "未标星"},{key: 1, value: "1星"},{key: 2, value: "2星"},{key: 3, value: "3星"},{key: 4, value: "4星"},{key: 5, value: "5星"}],
            tempLevels: [],
            showTitle: null,
            ssize:20,
            spage:1,
            stotle:0,
            tranTxt: {}
        }
    },
    methods: {
        analysis() {
            let _this = this;

            _this.loadding = true;

            if (_this.params.clickRate2) {
                _this.params.clickRate = _this.params.clickRate2 * 100
            }

            _this.$http.post(
                ["alibaba/keyword/startAnalysis", _this.params],
                [
                    function (data) {
                        _this.loadding = false;
                        _this.records = [];
                        _this.days = data.days;
                        _this.token = data.token;
                        _this.getDailyAnalysis(_this.days.shift())
                    },
                ],
                "none"
            );
        }
        ,getDailyAnalysis(date) {
            let _this = this;

            if (!date) {
                return;
            }

            _this.loadding = true;

            _this.$http.post(
                ["alibaba/keyword/getDailyAnalysis", {date: date.createDate, token: _this.token}],
                [
                    function (data) {
                        _this.loadding = false;

                        if (data) {
                            _this.records = _this.records.concat(data);
                        }
                        
                        _this.getDailyAnalysis(_this.days.shift());
                    },
                ],
                "none"
            );
        }
        ,showInfo(date, type, title) {
            let _this = this;

            _this.$http.post(
                ["alibaba/keyword/getAnalysisInfo", {date: date, type: type, token: _this.token}],
                [
                    function (data) {
                        _this.tempLevels = [];
                        _this.spage = 0;
                        _this.chars = {};
                        _this.tempData = [];
                        _this.showData = data;
                        _this.show = true
                        _this.showTitle = date + "--" + title
                        _this.next()
                    },
                ],
                ".data-div"
            );
        }
        ,showChar(data) {
            let _this = this;
            window.setTimeout(function() {
                for (var i in _this.tempData) {
                    if (i >= (_this.spage - 1) * _this.ssize && i < _this.spage * _this.ssize) {
                        _this.render(_this.tempData[i].key, _this.tempData[i].data);
                    }
                }
            }, 1)
        }
        ,render(key, data) {
            let _this = this;

            if (!_this.chars[key]) {
                let tdata = [];
                let adata = [];

                for (var i in data) {
                    tdata.push({date: data[i].d, type: "指数", data: data[i].p});
                    adata.push({date: data[i].d, type: "指数", data: data[i].p});
                    //tdata.push({date: data[i].d, type: "点击率", data: data[i].c});
                    tdata.push({date: data[i].d, type: "卖家", data: data[i].r});
                }

                _this.chars[key] = new Chart({ container: key, autoFit: true, height: 190});
                _this.chars[key].scale("data", {min: 0, nice: true});

                this.chars[key].tooltip({
                    showCrosshairs: true,
                    shared: true,
                });

                this.chars[key].scale({
                    data : {min : 0, nice: true, sync: true},
                    date : {nice: true, sync: true},
                });

                let v1 = this.chars[key].createView();
                v1.data(tdata)
                v1.line().position('date*data').color('type').shape('smooth');

                let v2 = this.chars[key].createView();
                v2.data(adata)
                v2.area().position('date*data').color('type').shape('smooth');

                _this.chars[key].render();
            }
        }
        ,changeLevel(key, level) {
            let _this = this;

            _this.$http.post(
                ["alibaba/keyword/markDailyLevels", {level: level, id: key}],
                [
                    function (data, message) {
                        message()
                    },
                ],
                ".data-div"
            );
        }
        ,getGradient(val, allVal) {
            let str = "background: linear-gradient(to bottom, transparent 0%, "
            let max = 0
            let data = allVal.split(",")

            for (var i = 0; i < data.length; i++) {
                if (window.parseInt(data[i]) > max) {
                    max = window.parseInt(data[i])
                }
            }

            if (val <= 0) {
                str += "transparent 100%);"
            } else {
                let num = window.parseFloat(val / max * 100).toFixed(4)

                str += "transparent " + (100 - num) + "%, #007ffc " +  (100 - num) + "%, #007ffc 100%);"
            }

            return str
        }
        ,disabled() {
            let _this = this;

            if (_this.tempData != null) {
                return _this.tempData.length == _this.stotle
            }

            return false
        }
        ,next() {
            let _this = this;
            let filteData = [];

            _this.spage = _this.spage + 1;

            if (_this.tempLevels == null || _this.tempLevels.length == 0) {
                filteData = _this.showData;
            } else {
                for (var i in _this.showData) {
                    if (_this.tempLevels.indexOf(_this.showData[i].l) != -1) {
                        filteData.push(_this.showData[i]);
                    }
                }
            }

            for (var i in filteData) {
                if (i >= (_this.spage - 1) * _this.ssize && i < _this.spage * _this.ssize) {
                    _this.tempData.push(filteData[i]);
                }
            }
            _this.stotle = filteData.length;
            _this.showChar();
            _this.txtTran();
        }
        ,txtTran() {
            let _this = this;
            let txt = [];

            for (var i in _this.tempData) {
                if (!_this.tempData[i].cn) {
                    txt.push(_this.tempData[i].key)
                }
            }
     
            _this.$http.post(
                ["txtTran/textTranslateBatch", {txt: txt.join(",")}],
                [
                    function (data) {
                       if (data != null) {
                            let temp = {};

                            for (var i in _this.tranTxt) {
                                temp[i] = _this.tranTxt[i]
                            }

                            for (var i in data) {
                                temp[i] = data[i]
                            }

                            _this.tranTxt = temp;
                       }
                    },
                ],
                ".showdata-drawer"
            );
        }
        ,fiterLevel() {
            let _this = this;
            _this.chars = {};
            _this.spage = 0;
            _this.tempData = [];
            window.setTimeout(function() {_this.next();}, 50)
        }
        
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .data-div{
        margin-left: 10px;
    }
    .showdata-div{
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 0 0 10px;

        .showdata-row{
            height: 200px;
        }
    }

    .info-tagrow {
        text-align: center;
        margin-top: -65px;
        width: 95%;

        .el-tag {
            margin-right: 10px;
        }
    }

    .alibaba-keywords-div-out {
        height: 75px;
        display: flex;
        border-bottom:1px solid #007ffc;
        width: 240px;
    }

    .alibaba-keywords-div {
        width: 10px;
        margin: 0 5px 0 5px;
        background: #007ffc;
    }

    .infinite-box-more {
        clear: both;
        text-align: center;
        font-size: 14px;
        color: #c0c4cc;
    }

    .totle-box{
            width: 50px;
            height: 24px;
            position: absolute;
            bottom: 10px;
            right: 20px;
            font-size: 12px;
            color: #c0c4cc;
        }
</style>